module.exports = __webpack_public_path__ + "img/ashish_chauhan.c8c1fad4.jpg";